module.exports = __webpack_public_path__ + "static/media/smile.da7f86bf.svg";